import { registerAll } from './register';

registerAll();
